import Icon from "./icon";
import Icons from "./icons";

import Vue from "vue";

export default {
    install() {
        Vue.mixin({
            computed: {
                $icons() {
                    return Icons;
                }
            }
        });
        Vue.component("Icon", Icon);
    }
};



// WEBPACK FOOTER //
// ./src/icons/index.js